import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BrandLogo } from "@/components/Brand";
import { LegalFooter } from "@/components/LegalFooter";
import { LEGAL } from "@/lib/legalTexts";

export default function LegalPage({ doc }) {
  const d = LEGAL[doc];
  useEffect(() => { window.scrollTo(0, 0); document.title = `${d.title} · Madonna Store`; }, [d]);
  return (
    <div className="flex min-h-screen flex-col bg-[#f8faf5]">
      <header className="border-b bg-white px-5 py-3"><div className="mx-auto max-w-3xl"><BrandLogo /></div></header>
      <main className="mx-auto w-full max-w-3xl flex-1 px-5 py-10" data-testid={`legal-page-${doc}`}>
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#61a229]" data-testid="legal-back-link"><ArrowLeft className="h-4 w-4" />Torna al sito</Link>
        <h1 className="mt-4 font-display text-4xl font-bold tracking-tight text-slate-900" data-testid="legal-title">{d.title}</h1>
        <p className="mt-3 text-sm text-slate-500">{d.intro}</p>
        <div className="mt-8 space-y-6 rounded-2xl border bg-white p-6 sm:p-8">
          {d.sections.map(([h, t]) => (
            <section key={h}>
              <h2 className="font-display text-base font-semibold text-slate-900 md:text-lg">{h}</h2>
              <p className="mt-1.5 whitespace-pre-line text-sm leading-relaxed text-slate-700">{t}</p>
            </section>
          ))}
        </div>
      </main>
      <LegalFooter />
    </div>
  );
}
